import { Stack } from '@chakra-ui/react'
import * as React from 'react'

import { IApiDeficitCreateRequest } from '../../../models/api/deficit/IApiDeficitCreateRequest';
import { IBaseDrawerProps } from '../BaseDrawer';
import { FormikProps } from 'formik';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';
import { TextAreaFormControl } from '../../formcontrols/TextAreaFormControl';

export interface IAddDeficitDrawerProps extends Omit<IBaseDrawerProps<IApiDeficitCreateRequest>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText"> {
    defaultValue?: IApiDeficitCreateRequest;
}

export const AddDeficitDrawer = (props: IAddDeficitDrawerProps) => {
    return (
        <BaseDrawerWithForm
            isOpen={props.isOpen}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue ?? {
                value: ""
            }}
            headerText="Eintrag erstellen"
        >
            {({ handleSubmit, errors, touched, isSubmitting }: FormikProps<IApiDeficitCreateRequest>) => (
                <Stack px="0" spacing="4">
                    <TextAreaFormControl 
                        field="value"
                        label="Text"
                        isInvalid={(errors.value && touched.value) ? true : false}
                        isDisabled={isSubmitting}
                        validate={(value: string) => {
                            let error;
                            if (value === null || value === undefined || value.length < 1) {
                                error = "Text ist erforderlich!";
                            }
                            return error;
                        }}
                        errorMessage={errors.value}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}